import PropTypes from 'prop-types';
import AgentPropType from './AgentPropType';

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  members: PropTypes.arrayOf(AgentPropType).isRequired,
  userCount: PropTypes.number.isRequired,
});
